<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h2 class="headline font-weight-bold">
              Kegiatan Saat Ini: <span class="primary--text">Pembagian Kuota KS Tiap Daerah</span>
            </h2>
            <div>
              Silakan untuk melakukan set kuota Kepala Sekolah yang diterima untuk semua jenjang dan daerah pada daftar
              <h4 class="title orange--text">Jadwal Kegiatan</h4>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <v-row no-gutters class="py-2">
                        <v-col cols="8">
                          Nama Kegiatan
                        </v-col>
                        <v-col cols="4">
                          Tanggal Pelaksanaan
                        </v-col>
                        <!--                        <v-col cols="1" md="1">-->
                        <!--                          status-->
                        <!--                        </v-col>-->
                      </v-row>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in jadwals" :key="i">
                      <td class="px-0">
                        <v-row no-gutters class="py-2">
                          <v-col cols="8">
                            {{ item.kegiatan }}
                          </v-col>
                          <v-col cols="4">
                            {{ item.tgl_kegiatan }}
                          </v-col>
                          <!--                          <v-col cols="1" md="1">-->
                          <!--                            <v-icon :color="item.status === 1 ? 'success' : item.status === 0 ? 'info' : 'grey'">-->
                          <!--                              {{-->
                          <!--                                item.status === 1-->
                          <!--                                  ? 'mdi-check-circle'-->
                          <!--                                  : item.status === 0-->
                          <!--                                  ? 'mdi-circle-slice-5'-->
                          <!--                                  : 'mdi-alert-circle'-->
                          <!--                              }}-->
                          <!--                            </v-icon>-->
                          <!--                          </v-col>-->
                        </v-row>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <!--            <v-alert-->
            <!--              icon="mdi-alert"-->
            <!--              colored-border-->
            <!--              class="pa-2 my-2 bg-notif"-->
            <!--              color="warning"-->
            <!--              style="border-width: 0 !important;"-->
            <!--              v-if="is_konfirmasi_kuota"-->
            <!--            >-->
            <!--              <p class="body-2 mb-0 black&#45;&#45;text">-->
            <!--                Jika semua data terkait Kuota Kepala Sekolah yang akan diterima pada semua jenjang dan daerah sudah-->
            <!--                lengkap, Anda melakukan konfirmasi data untuk mengirimkan informasi dan melanjutkan ke tahap-->
            <!--                selanjutnya.-->
            <!--              </p>-->
            <!--              <v-btn-->
            <!--                class="mt-2"-->
            <!--                color="orange"-->
            <!--                dark-->
            <!--                small-->
            <!--                style="text-transform: capitalize"-->
            <!--                depressed-->
            <!--                @click="onConfirm"-->
            <!--              >-->
            <!--                <v-icon left dark>-->
            <!--                  mdi-send-->
            <!--                </v-icon>-->
            <!--                Konfirmasi Data-->
            <!--              </v-btn>-->
            <!--            </v-alert>-->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- <statistik :value="statistik"></statistik>-->
    <!--daftar-->
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          :btnFilter="true"
          :btnDownload="true"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
          @download="onDownload"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :disable-close="true"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterSave"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-row no-gutters>
                <v-col cols="12" md="4">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue">
                      <v-icon dark>mdi-office-building-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="subtitle-2 blue--text">
                        {{ $getDeepObj(item.instansi, 'nama') || '-' }}
                      </div>
                      <div class="black--text" v-if="getOperator(item)">
                        <v-icon dark color="#5ED093">mdi-account</v-icon>
                        {{ getOperator(item) || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list-item>
                    <div>
                      <div>
                        <span class="caption grey--text">Tahapan yang Sedang Dikerjakan</span>
                      </div>
                      <div>
                        <span class="mb-0">
                          {{ $getDeepObj(item, 'm_tahap_peringkat_psp.tahap') }}
                        </span>
                      </div>
                    </div>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list-item>
                    <div>
                      <div>
                        <span class="caption grey--text">Status Tahapan</span>
                      </div>
                      <div class="body-2">
                        <v-chip
                          dark
                          small
                          :color="WARNA_STATUS[$getDeepObj(item, 'm_tahap_peringkat_psp.status').toLowerCase()]"
                        >
                          {{ $getDeepObj(item, 'm_tahap_peringkat_psp.status') }}
                        </v-chip>
                      </div>
                    </div>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="2">
                  <v-list-item>
                    <v-list-item-content class="pt-1">
                      <div>
                        <div>
                          <span class="caption grey--text">Aksi</span>
                        </div>
                        <div>
                          <v-btn depressed small dark color="blue" @click="onDetail(item)">
                            Selengkapnya
                          </v-btn>
                        </div>
                      </div>
                    </v-list-item-content>
                    <!--                    <v-list-item-action-text>-->
                    <!--                      <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />-->
                    <!--                    </v-list-item-action-text>-->
                  </v-list-item>
                </v-col>
              </v-row>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full ref="modal" :title="formulir.title" :use-save="formulir.useSave">
      <component
        ref="formulir"
        :is="formulir.form"
        :isPreview="formulir.isPreview"
        :detail="formulir.detail"
        :mJenjang="formulir.mJenjang"
        @reload="onDetail"
        @reset="onReset"
        @confirm="onConfirm"
      />
    </base-modal-full>
    <popup-konfirmasi ref="konfirm" @save="onConfirmSave"></popup-konfirmasi>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import actions from './action';
import FormPagu from './Formulir';
import PopupKonfirmasi from './formulir/PopupKonfirmasi';
import { isExistArray } from '@utils/format';
export default {
  name: 'Index',
  mixins: [list],
  components: { FormPagu, PopupKonfirmasi },
  data() {
    return {
      actions: actions,
      formulir: {},
      listPa: {},
      id: null,
      panel: [],
      is_konfirmasi_kuota: false,
      M_TAHAPAN: {
        1: { label: '1. Verval Data', step: 1 },
        2: { label: '1. Verval Data', step: 1 },
        4: { label: '2. Seleksi Peserta', step: 2 },
        5: { label: '3. Pembagian Kuota', step: 3 },
        6: { label: '3. Konfirmasi Pusat', step: 3 },
        7: { label: '4. Berita Acara', step: 4 },
        8: { label: '4. Berita Acara', step: 4 },
        9: { label: '4. Berita Acara', step: 4 },
        10: { label: '5. Selesai', step: 5 },
      },
      M_TAHAP_FILTER: {
        1: 'Verval Data',
        2: 'Seleksi Peserta',
        4: 'Konfirmasi Pusat (Belum)',
        6: 'Konfirmasi Pusat (Sudah)',
        7: 'Berita Acara (Final)',
        8: 'Berita Acara (Ajuan)',
        9: 'Berita Acara (Perbaikan)',
        10: 'Selesai',
      },
      WARNA_STATUS: {
        belum: 'error',
        ajuan: '#FF7F2A',
        perbaikan: '#FF7F2A',
        sudah: 'success',
        selesai: 'success',
      },
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    filtersMaster() {
      return {
        k_tahap_peringkat_psp: this.M_TAHAP_FILTER,
      };
    },

    formFilter() {
      return [
        {
          label: 'Tahapan yang sedang dikerjakan',
          default: true,
          type: 'checkbox',
          model: 'k_tahap_peringkat_psp',
          master: this.$mapForMaster(this.M_TAHAP_FILTER),
        },
      ];
    },

    jadwals() {
      return [
        {
          kegiatan: 'Verval Data dan Penilaian Kepala Sekolah',
          tgl_kegiatan: '20 Juni - 8 Juli 2022',
          status: 1,
        },
        {
          kegiatan: 'Pembagian Kuota Kepala Sekolah yang Diterima',
          tgl_kegiatan: '9 - 10 Juli 2022',
          status: 0,
        },
        {
          kegiatan: 'Verval dan Perssetujuan Berita Acara',
          tgl_kegiatan: '11 - 15 Juli 2022',
          status: -1,
        },
      ];
    },
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('peringkatVerval', ['fetch', 'getDetail', 'action', 'downloadList']),

    isExistArray(source, target) {
      return isExistArray(source, target);
    },

    getOperator(data) {
      const tahaps = (data && data.psp_peringkat_tahaps) || [];
      const length = tahaps.length;
      return length ? tahaps[length - 1] && tahaps[length - 1]['akun'] && tahaps[length - 1]['akun']['nama'] : '';
    },

    fetchData: function() {
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const attr = Object.assign({}, this.attr);
        this.fetch({ params, attr }).then(({ data, meta, total, last_page, per_page, is_konfirmasi_kuota }) => {
          this.data = data || [];
          this.total = total || meta?.total || 0;
          this.pageTotal = last_page || meta?.last_page || 1;
          this.params.limit = per_page || meta?.per_page || this.params.limit;
          this.statistik = meta?.statistik || {};
          this.config = meta?.config || {};
          this.is_konfirmasi_kuota = is_konfirmasi_kuota || false;
          resolve(true);
        });
      });
    },

    filterSave(filters) {
      let newFilters = Object.assign({}, filters);

      if (newFilters.k_tahap_peringkat_psp) {
        if (newFilters.k_tahap_peringkat_psp.includes(4)) {
          if (!newFilters.k_tahap_peringkat_psp.includes(5)) {
            newFilters.k_tahap_peringkat_psp = [...filters.k_tahap_peringkat_psp, ...[5]];
          }
        } else {
          newFilters.k_tahap_peringkat_psp = newFilters.k_tahap_peringkat_psp.filter((tahap) => ![5].includes(tahap));
        }
      }

      // set filter
      this.filters = newFilters;
      Object.assign(this.params, { page: 1 });
      this.fetchData().then(() => {
        this.$refs.filter.close();
      });
    },

    async onDetail(item) {
      const { psp_peringkat, m_jenjangs } = await this.getDetail({ id: item.psp_peringkat_id });
      this.$set(this.formulir, 'form', 'FormPagu');
      this.$set(this.formulir, 'title', 'Detail Pengisian Borang');
      this.$set(this.formulir, 'useSave', false);
      this.$set(this.formulir, 'isPreview', true);
      this.$set(this.formulir, 'detail', psp_peringkat);
      this.$set(this.formulir, 'mJenjang', m_jenjangs);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.fetchDataChild();
      });
    },

    onConfirm(item) {
      this.$refs.konfirm.color = 'orange';
      this.$refs.konfirm.okLabel = 'Ya, Data Sesuai';
      this.$refs.konfirm.jenis = 'konfirmasi-kuota-dinas';
      this.$refs.konfirm.title = `Apakah Anda yakin bahwa pengisian Sebaran Satuan Pendidikan Kepala Sekolah yang diterima untuk semua jenjang di
      ${this.$getDeepObj(item.instansi, 'nama')} sudah benar ?`;
      this.$refs.konfirm.desc = `
          Proses ini akan mengkonfirmasi bahwa Sebaran Satuan Pendidikan Kepala Sekolah yang telah Anda isikan sudah benar dan akan
          dikirimkan ke semua Operator Dinas Daerah terkait
          <span class="error--text body-2">
            (pembatalan Sebaran Satuan Pendidikan hanya bissa dilakukan dengan reset tahapan <b>3.Konfirmasi Pusat</b> pada tiap-tiap
            daerah)
          </span>
      `;
      this.$refs.konfirm.quote = 'Sebaran Satuan Pendidikan Kepala Sekolah yang saya isikan sudah benar';
      this.$refs.konfirm.open();
    },

    onConfirmSave() {
      this.action({
        id: this.$getDeepObj(this.formulir, 'detail.psp_peringkat_id'),
        aksi: this.$refs.konfirm.jenis,
      }).then(async () => {
        // this.$refs.modal.close();
        await this.fetchData();
        if (this.$refs.konfirm.jenis === 'reset-tahap' || this.formulir.form === 'FormPagu') {
          this.onDetail(this.formulir.detail);
        }
        this.$success('Aksi berhasil disimpan');
        this.$refs.konfirm.close();
      });
    },

    onReset() {
      this.$refs.konfirm.color = 'error';
      this.$refs.konfirm.okLabel = 'Ya, Reset Data';
      this.$refs.konfirm.jenis = 'reset-tahap';
      this.$refs.konfirm.title = `Apakah Anda yakin bahwa akan mereset tahap ${
        this.M_TAHAPAN[this.$getDeepObj(this.formulir, 'detail.k_tahap_peringkat_psp')]['label']
      } milik PMO ${this.$getDeepObj(this.formulir, 'detail.instansi.nama')}?`;
      this.$refs.konfirm.desc = `
          Proses ini akan mengkonfirmasi bahwa semua data pada tahap ${
            this.M_TAHAPAN[this.$getDeepObj(this.formulir, 'detail.k_tahap_peringkat_psp')]['label']
          } milik PMO ${this.$getDeepObj(this.formulir, 'detail.instansi.nama')} akan hilang dan kembali ke tahap
          sebelumnya.
          <span class="error--text body-2">
            (data pda tahap ini kemungkinan akaan hilang secara permanen)
          </span>
      `;
      this.$refs.konfirm.quote = `Saya sangat yakin untuk mereset tahap ${
        this.M_TAHAPAN[this.$getDeepObj(this.formulir, 'detail.k_tahap_peringkat_psp')]['label']
      }`;
      this.$refs.konfirm.open();
    },

    onDownload() {
      const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
      const attr = Object.assign({}, this.attr);
      this.downloadList({ params, attr }).then((url) => {
        window.open(url, '_blank');
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
